import React from 'react';

const CustomCircularProgress = ({
	progress,
	size = 100,
	strokeWidth = 8,
	progressColor = '#007bff',
	backgroundColor = '#e6e6e6',
	textColor = '#007bff',
	loadingText = 'Loading PDF...',
	showText = true,
	showPercentage = true,
	className = ''
}) => {
	const radius = (size - strokeWidth) / 2;
	const circumference = radius * 2 * Math.PI;
	const strokeDasharray = circumference;
	const strokeDashoffset = circumference - (progress / 100) * circumference;

	return (
		<div className={`d-flex flex-column align-items-center ${className}`}>
			<div style={{ position: 'relative', width: size, height: size }}>
				<svg
					width={size}
					height={size}
					viewBox={`0 0 ${size} ${size}`}
					style={{ transform: 'rotate(-90deg)' }}
				>
					<circle
						cx={size / 2}
						cy={size / 2}
						r={radius}
						stroke={backgroundColor}
						strokeWidth={strokeWidth}
						fill="none"
					/>

					<circle
						cx={size / 2}
						cy={size / 2}
						r={radius}
						stroke={progressColor}
						strokeWidth={strokeWidth}
						fill="none"
						strokeDasharray={strokeDasharray}
						strokeDashoffset={strokeDashoffset}
						strokeLinecap="round"
						style={{
							transition: 'stroke-dashoffset 0.3s ease'
						}}
					/>
				</svg>

				{showPercentage && (
					<div
						style={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%)'
						}}
					>
						<span
							className="semibold-16"
							style={{
								color: textColor,
								fontSize: size > 80 ? '16px' : size > 60 ? '14px' : '12px'
							}}
						>
							{progress}%
						</span>
					</div>
				)}
			</div>
			{showText && loadingText && (
				<p
					className="mt-2 mb-0 regular-14"
					style={{
						color: '#666',
						fontSize: size > 80 ? '14px' : '12px'
					}}
				>
					{loadingText}
				</p>
			)}
		</div>
	);
};
export default CustomCircularProgress;
